import React from "react"
import { useTranslation } from "react-i18next"
import { motion } from "framer-motion"

const TripButton = ({ item, isActive, onClick }) => {
  const { t } = useTranslation()

  //
  const { trans_key } = item

  return (
    <motion.button
      layout
      className="px-3 py-1 rounded-md cursor-pointer text-second-success relative overflow-hidden"
      onClick={onClick}
      style={{ zIndex: 1 }}
    >
      {isActive && (
        <motion.div
          layoutId="highlight"
          className="absolute top-0 left-0 w-full h-full rounded-md bg-second-success"
          style={{ zIndex: -1 }}
          transition={{ type: "spring", stiffness: 400, damping: 30 }}
        />
      )}
      <span className={isActive ? "text-white relative z-10" : "relative z-10"}>
        {t(trans_key)}
      </span>
    </motion.button>
  )
}

export default TripButton
